/* eslint-disable max-lines */
import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
import btnAuthority from '@/modules/mdm/btnAuthority.js';

export const config = {
    name: 'typeReport',
    searchFields: [
        {
            name: '目标类型名称',
            value: 'goalTypeName',
            type: 'input',
            isFixed: true,
            span: 6
        },
        {
            name: '状态',
            value: 'goalTypeStatus',
            type: 'select',
            optionNum: 'CRM_GOAL_STATUS',
            isFixed: true,
            span: 6
        }
    ],
    selection: false,
    index: false,
    columns: [
        {
            label: '目标类型编码',
            prop: 'goalTypeCode'
        },
        {
            label: '目标类型名称',
            prop: 'goalTypeName',
            type: 'input',
            mustFill: true
        },
        {
            label: '状态',
            prop: 'goalTypeStatus',
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'CRM_GOAL_STATUS'
        },
        {
            label: '创建人',
            prop: 'createUserName'
        },
        {
            label: '创建时间',
            prop: 'createTime'
        },
        {
            label: '修改人',
            prop: 'updateUserName'
        },
        {
            label: '修改时间',
            prop: 'updateTime'
        }
    ],
    actions: { // 表格操作列的配置
        fixedWidth: 100, // fixedWidth（可选） 设置操作列的固定宽度，不加该参数默认是按钮list长度*50px
        list: []
    },
    rowEdit: otherUtils.getHasAuth(btnAuthority.typeReport.save),
    getAuthRole: () => otherUtils.getHasAuth(btnAuthority.typeReport.edit),
    rowEnableEditFun: (row) => { // 是否可编辑（编辑按钮和双击编辑）
        const isAuth = otherUtils.getHasAuth(btnAuthority.typeReport.edit);
        return isAuth;
    }

};
